import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Partner } from "../components/Partner";
import AOS from "aos";
import "aos/dist/aos.css";

export const AboutUs = () => {

useEffect(() => {
    AOS.init({
        duration: 1500,
        once: true,
        disable: function () {
            return window.innerWidth < 992;
        },
    });
}, []);
   
return(
<div className="page-content aboutpage">
    <section className="wi_full py_3 inner_banner" style={{backgroundImage: "url('./images/about-banner.jpg')",backgroundSize: "cover",
        backgroundPosition: "center", backgroundRepeat: "no-repeat",}}>
        <div className="container" data-aos="fade-in">
            <h1>About Us</h1>
        </div>
    </section>
    <section className="who_we_about py_3 wi_full">
        <div className="container">
            <div className="row align-items-center" data-aos="fade-up">
                <div className="col-lg-6 content_col">
                    <h2>Who we <span>are</span></h2>
                    <p>We are your local health insurance advisors, certified by the NJ state and Federal Governtment.  We help people just like you find health plans that provide peace of mind — not confusion.</p>
                    <p>With 22 years of experience and partnerships with top insurers,our team will guide individuals and families through their options with clear advice and zero jargon.</p>
                    <p><strong>Our goal:</strong> Make your health insurance simple, stress-free, and perfectly tailored to your needs.</p>
                </div>
                <div className="col-lg-6 img_col mt-4 mt-lg-0">
                    <img src="./images/who-about.png" alt="#" className="w-100" />
                </div>
            </div>
        </div>
    </section>
    <section className="apart_about wi_full py_3 pt-0 mt_3">
        <div className="container position-relative">
            <div className="row flex-lg-row-reverse" data-aos="fade-up">
                <div className="col-lg-6 content_col align-self-center pt-4">
                    <h2>What sets us <span>apart?</span></h2>
                    <ul className="tick_list">
                        <li>Local & Personalized Support</li>
                        <li>Access to Top Insurance Carriers</li>
                        <li>Clear Explanations in your preferred language, No Jargon</li>
                        <li>No Extra Fees — You Pay the Same Premium</li>
                        <li>Year-Round Support, Not Just During Open Enrollment</li>
                    </ul>
                    <p>Personalized service with multilingual support. We’re proud to assist clients in English, Hindi, and Punjabi — because we believe language should never be a barrier to understanding your healthcare options.</p>
                </div>
                <div className="col-lg-6 img_col mt-4 mt-lg-0">
                    <img src="./images/image-apart.jpg" alt="#" className="w-100" />
                </div>
            </div>
        </div>
    </section>
    <section className="whatget_about py_3 wi_full mt_3">
        <div className="container position-relative">
            <div className="row align-items-center" data-aos="fade-up">
                <div className="col-lg-6 content_col">
                    <h2>What you <span>get?</span></h2>
                    <p><strong>One-on-One Guidance –</strong> You get real answers from a real person.</p>
                    <p><strong>Access to Leading Carriers –</strong> Compare plans from top insurers in one place.</p>
                    <p><strong>Clear, Friendly Communication –</strong> No jargon. No sales pressure. Just honest help.</p>
                    <p><strong>No Extra Costs –</strong> You pay the same price whether you use an agent or not.</p>
                    <p>We're not a call center. We're your health insurance partner — guiding you to the right plan with no stress, no sales pressure, and no added cost.</p>
                </div>
                <div className="col-lg-6 img_col mt-4 mt-lg-0">
                    <img src="./images/what-get.jpg" alt="#" className="w-100" />
                </div>
            </div>
        </div>
    </section>
    <Partner />
</div>
)
}